import React from 'react'
import DueForm from './DueForm'
import { usePutRequest } from '../hooks/request'
import { DUE_DETAIL } from '../urls'
import { useMessage } from '../hooks/message'

export default function DueUpdate({ onCancel, item, onUpdate }) {
    const brandUpdate = usePutRequest({ url: DUE_DETAIL.replace('{id}', item.id) })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success } = await brandUpdate.request({ data })

        if (success) {
            showMessage('Успешно изменена', 'is-success')
            onUpdate()
            onCancel()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered"><b>Изменить</b></h1>

            <DueForm
                loading={brandUpdate.loading}
                initialValues={item}
                onSubmit={onSubmit}
                onCancel={onCancel} />
        </div>
    )
}
